'use strict';
var twentyninetimes = twentyninetimes || {};
const mosaicMediaWithVideo = document.querySelectorAll('.js-block-mosaic-area.has-video');
const mosaicGreenVideos = document.querySelectorAll('.js-block-mosaic-video-green');

twentyninetimes.mosaic = twentyninetimes.mosaic || function () {

	function init() {

        if(mosaicGreenVideos.length > 0) {
            mosaicGreenVideos.forEach(video => {
                video.play();
            });
        }

        mosaicMediaWithVideo.forEach(element => {
            //Desktop (play videos on hover)
            if (window.innerWidth > 767 ) {
                element.addEventListener('mouseover', function(e){
                    const hoverElement = e.currentTarget;
                    const videoElement = hoverElement.querySelector('video');
                    videoElement.play();
                    hoverElement.classList.add('hover');
                });
                
                element.addEventListener('mouseleave', function(e){
                    const hoverElement = e.currentTarget;
                    const videoElement = hoverElement.querySelector('video');
                    
                    if (!hoverElement.classList.contains('block-mosaic-area--green')) {
                        videoElement.pause();
                        hoverElement.classList.remove('hover');
                    }

                });
            }
            // Mobile (autoplay videos)
            else {
                const videoElement = element.querySelector('video');
                element.classList.add('hover');
                videoElement.play();
            }
        });
	}

	return {
		init : init
	};

}();